module.exports = __webpack_public_path__ + "static/media/email-logo.7a4b1012.svg";